import { SpectraDevice } from "../views/components/Common/SpectraDeviceSelect";
import { ISampleRecordPopulated, SpectraDeviceNames } from "../types/sample";

export function detectSpectraDeviceFromSample(
  sample?: Pick<ISampleRecordPopulated, "spectraDeviceName" | "spectraDeviceId">
): SpectraDevice | undefined {
  if (!sample) return undefined;

  if (sample.spectraDeviceName != null) {
    const key = Object.keys(SpectraDeviceNames).find(
      (k) =>
        SpectraDeviceNames[k as keyof typeof SpectraDeviceNames] ===
        sample.spectraDeviceName
    );
    if (key && key in SpectraDevice) {
      return SpectraDevice[key as keyof typeof SpectraDevice];
    }
  }

  if (sample.spectraDeviceId?.toLowerCase().startsWith("r60")) {
    return SpectraDevice.R60s;
  }

  return undefined;
}

export function detectSpectraDeviceFromSamples(
  samples: Pick<ISampleRecordPopulated, "spectraDeviceName" | "spectraDeviceId">[]
): SpectraDevice | undefined {
  const deviceName = samples?.filter(s=>s.spectraDeviceName)?.[0]?.spectraDeviceName;
  if(deviceName == SpectraDeviceNames.BlueSun) {
    return SpectraDevice.BlueSun;
  } else if(deviceName == SpectraDeviceNames.Foss) {
    return SpectraDevice.Foss;
  } else if(deviceName == SpectraDeviceNames.R60s) {
    return SpectraDevice.R60s;
  } else if(deviceName == SpectraDeviceNames.Phoenix5000) {
    return SpectraDevice.BlueSun;
  } else {
    return undefined;
  }
}
